<template>
  <div>
    <div class="" :class="btnPosition.btnHistoryClass || ''">
      <div
        :class="btnPosition.btnClass || ''"
        :style="btnPosition.btnStyle || ''"
        role="group"
      >
        <button class="btn btn-outline-primary next-btn" @click="previous">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
          {{ $t("global.return") }}
        </button>
        <button
          v-if="step === 2"
          class="btn btn-primary wizard-btn next-btn"
          @click="nextStep"
          :disabled="!comments || comments.length === 0"
        >
          {{ $t("global.next") }}
          <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
        <button
          v-else
          class="btn btn-primary wizard-btn next-btn"
          @click="saveRequest"
        >
          {{ $t("global.save") }}
        </button>
      </div>
    </div>

    <div class="row" v-if="step == 3">
      <div class="col-md-12 col-lg-8">
        <div class="row">
          <div class="col-md-6" v-for="(date, idx) in mappedDates" :key="idx">
            <div class="card card-small mb4 mt-3">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="date-header">
                      <p>{{ formatDate(date.to) }}</p>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-6">
                    <div class="step4-card">
                      <div class="d-flex">
                        <div class="svg-wrapper">
                          <svg
                            width="44px"
                            height="44px"
                            viewBox="0 0 44 44"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                            <title>Iconspace_Calendar</title>
                            <desc>Created with Sketch.</desc>
                            <g
                              id="Page-1"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="Antarmuka_One-Color-UI-element-1"
                                transform="translate(-338.000000, -242.000000)"
                              >
                                <g
                                  id="Iconspace_Calendar"
                                  transform="translate(336.000000, 240.000000)"
                                >
                                  <polygon
                                    id="Shape"
                                    points="0 0 48 0 48 48 0 48"
                                  />
                                  <path
                                    d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                                    id="Shape"
                                    fill="#303778"
                                    fill-rule="nonzero"
                                  />
                                  <polygon
                                    id="Shape"
                                    fill="#303778"
                                    points="10 18 18 18 18 26 10 26"
                                  />
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <div>
                          <p>{{ $t("days.off.request.from") }}</p>
                          <span>
                            {{ formatTime(date.from) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 col-lg-6">
                    <div class="step4-card">
                      <div class="d-flex">
                        <div class="svg-wrapper">
                          <svg
                            width="44px"
                            height="44px"
                            viewBox="0 0 44 44"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                          >
                            <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                            <title>Iconspace_Calendar</title>
                            <desc>Created with Sketch.</desc>
                            <g
                              id="Page-1"
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <g
                                id="Antarmuka_One-Color-UI-element-1"
                                transform="translate(-338.000000, -242.000000)"
                              >
                                <g
                                  id="Iconspace_Calendar"
                                  transform="translate(336.000000, 240.000000)"
                                >
                                  <polygon
                                    id="Shape"
                                    points="0 0 48 0 48 48 0 48"
                                  />
                                  <path
                                    d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                                    id="Shape"
                                    fill="#303778"
                                    fill-rule="nonzero"
                                  />
                                  <polygon
                                    id="Shape"
                                    fill="#303778"
                                    points="10 18 18 18 18 26 10 26"
                                  />
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                        <div>
                          <p>{{ $t("days.off.request.to") }}</p>
                          <span>
                            {{ formatTime(date.to) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 col-lg-4">
        <div class="card card-small mb-4 mt-3">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-center py-5">
              <div class="wrapper white">
                <h5>{{ user.freeHoursAvailable }}</h5>
                <span>{{ $t("recovery.time.request.hours") }}</span>
                <br />
                <small>{{
                  $t("recovery.time.request.actual.overtime.hours")
                }}</small>
              </div>
              <i class="fas fa-arrow-right px-3"></i>
              <div class="wrapper blue">
                <h5 v-if="$route.name == 'recovery-time-request'">
                  {{ user.freeHoursAvailable + totalHours }}
                </h5>
                <h5 v-else>
                  {{ user.freeHoursAvailable - totalHours }}
                </h5>
                <span>{{ $t("recovery.time.request.hours") }}</span>
                <br />
                <small>{{
                  $t("recovery.time.request.new.overtime.hours")
                }}</small>
              </div>
            </div>

            <div>
              <p>{{ comments }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-else>
      <div class="col-md-12 col-lg-6">
        <div class="card card-small mb-4 mt-3">
          <div class="card-body">
            <div class="select-date">
              <h6>
                {{ $t("recovery.time.request.fill.date") }}
                <sup class="text-red">*</sup>
              </h6>

              <div class="heading-wrapper">
                <h5>{{ totalHours }}</h5>
                <span>{{ $t("recovery.time.request.hours") }}</span>
                <br />
                <small v-if="$route.name == 'recovery-time-request'">{{
                  $t("recovery.time.request.hours.add")
                }}</small>
                <small v-else>{{
                  $t("recovery.time.request.hours.remove")
                }}</small>
              </div>
            </div>

            <div
              class="row date-bg-color align-items-center py-3"
              v-for="(model, idx) in dates"
              :key="idx"
            >
              <div class="col-md-10">
                <date-time
                  placeholder="Date"
                  @updateDate="(date) => updateDate(idx, date)"
                  :minDays="false"
                />
              </div>

              <div class="delete-icon">
                <button
                  class="btn btn-danger mt-4"
                  @click="removeDate(idx)"
                  :disabled="dates.length === 1"
                >
                  <span class="fa fa-trash"></span>
                </button>
              </div>
            </div>

            <div class="row">
              <p class="px-3 pb-0 mb-0 py-2 new-date" @click="addDate">
                <i class="fas fa-plus-square mr-2"></i
                ><span>{{
                  $t("recovery.time.request.step.two.add.new.day")
                }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 col-lg-6">
        <div class="card card-small mb-4 mt-3">
          <div class="card-body">
            <h6>{{ $t("recovery.time.request.overtime.hours") }}</h6>
            <textarea
              v-model="comments"
              class="form-control col-md-12"
              cols="30"
              rows="7"
              :placeholder="$t('recovery.time.request.explain.here')"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="card card-small mb-4 mt-3">
      <div class="card-header inner-head border-bottom">
        <h6 class="inner-head__heading m-0">{{ $t('days.off.request.for') }} {{ user.lastName }} {{ user.firstName }}</h6>
      </div>
      <div class="card-body">
        <div class="py-2 px-3">
          <slot name="topText"></slot>
          <div class="row">
            <div class="col-md-6">
            <button v-if="step === 2" class="btn btn-primary mb-4" @click="addDate">Ajouter une date</button>
            <div v-else></div>
            </div>
            <div class="col-md-6 d-flex justify-content-end">
              <p>Total d'heures declares : {{ formatTotalHours(totalHours) }}</p>
            </div>


          </div>
          <div class="row" v-for="(model, idx) in dates" :key="idx">
            <div class="col-lg-11">
              <date-time
                placeholder="Date"
                @updateDate="(date) => updateDate(idx, date)"
                :disabled="step === 3"
                :minDays="false"/>
            </div>
            <div class="col-lg-1 text-right" v-if="step === 2">
              <button class="btn btn-danger mt-4" @click="removeDate(idx)" :disabled="dates.length === 1"><span class="fa fa-trash"></span></button>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <p>Commentaire (facultatif) :</p>
            </div>
            <div class="col-md-6">
            <textarea v-model="comments" class="form-control col-md-12" cols="20" rows="5" :disabled="step === 3"></textarea>

            </div>
          </div>
          <div class="d-flex align-content-end mt-5" style="justify-content: flex-end;">
            <button class="btn btn-danger mr-3" @click="previous">{{ $t('global.return') }}</button>
            <button v-if="step === 2" class="btn btn-success" @click="nextStep">{{ $t('global.next') }}</button>
            <button v-else class="btn btn-success" @click="saveRequest">{{ $t('global.save') }}</button>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import TimeUtils from '../../../utils/TimeUtils';
import DateTime from '../../form/DateTime';

export default {
  name: 'StepTwoRecoveryTime',
  components: { DateTime },
  props: {
    user: Object,
    step: Number,
  },
  data() {
    return {
      dates: [{}],
      comments: null,
      mappedDates: null,
    };
  },
  computed: {
    totalHours() {
      if (this.step == 2) {
        let total = 0;
        this.dates.forEach((date) => {
          total += TimeUtils.getTimeDifference(
            {
              hour: date.startHour || 0,
              minute: date.startMinute || 0,
            },
            {
              hour: date.endHour || 0,
              minute: date.endMinute || 0,
            },
          );
        });
        return total;
      } else if (this.step == 3) {
        let total = 0;
        this.mappedDates.forEach((date) => {
          total += TimeUtils.getTimeDifferenceBetween(date.from, date.to);
        });
        return total;
      }
    },
    btnPosition() {
      const buttonStyle = {
        btnHistoryClass: 'btn-wrapper d-flex justify-content-between',
        btnClass: 'btn-group ml-md-auto mr-md-0 mx-auto',
      };
      return buttonStyle;
    },
  },
  methods: {
    // formatTotalHours(time) {
    //   const total = time.toString().split('.');
    //   return `${total[0] === '0' ? '00' : total[0]}h${TimeUtils.formatMinutes(total[1])}`;
    // },
    updateDate(index, date) {
      this.$set(this.dates, index, date);
    },
    addDate() {
      this.dates.push({});
    },
    removeDate(index) {
      if (this.dates.length === 1) {
        return;
      }
      this.dates.splice(index, 1);
    },
    previous() {
      this.$emit('input', { dates: null });
    },
    nextStep() {
      this.mappedDates = this.dates.map(date => ({
        from: TimeUtils.getDateFrom(
          date.date,
          date.startHour,
          date.startMinute,
        ),
        to: TimeUtils.getDateFrom(date.date, date.endHour, date.endMinute),
      }));
      this.$emit('input', { dates: this.mappedDates, comments: this.comments });
    },
    saveRequest() {
      this.$emit('saveRequest', this.totalHours);
    },
    formatDate(date) {
      return TimeUtils.formatDate(date);
    },
    formatTime(date) {
      return TimeUtils.formatTime(date);
    },
  },
};
</script>

<style scoped>
.btn.btn-outline-primary {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  color: #4f78e2;
  border-color: #4f78e2;
  box-shadow: none !important;
}

.btn.btn-outline-primary:hover {
  color: #4f78e2;
  border-color: #4f78e2;
  background-color: transparent;
}

.btn.btn-primary {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  color: #ffffff !important;
}

.text-red {
  color: red;
}

@media (max-width: 767px) {
  .heading-wrapper {
    width: 80px !important;
  }
}

@media (max-width: 320px) {
  .heading-wrapper {
    width: 70px !important;
  }
}

.delete-icon {
  position: absolute;
  vertical-align: middle;
  right: 20px;
}

.heading-wrapper {
  position: absolute;
  top: 5px;
  right: 5px;
  text-align: center;
  background-color: #303778;
  padding: 15px 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 20px 0px #e9ecef;
  margin-bottom: 15px;
}

.heading-wrapper h5 {
  margin-bottom: 0;
  font-weight: bold;
  color: #ffffff;
}

.heading-wrapper span {
  color: #ffffff;
}

.heading-wrapper small {
  text-transform: uppercase;
  color: #ffffff;
}

.select-date {
  position: relative;
}

.new-date {
  color: #4f78e1;
  cursor: pointer;
}

.row.date-bg-color:nth-child(odd) {
  background-color: #f6f8ff;
}

.step4-card {
  padding: 15px;
  min-height: 70px;
  border-radius: 0;
  border-left: 5px solid #303778;
  margin-bottom: 5px;
  background-color: #f6f8ff;
}

.svg-wrapper svg {
  height: 20px;
}

.step4-card p {
  color: #32356b;
  margin-bottom: 10px;
}

.step4-card span {
  color: #6c7899;
}

.wrapper {
  text-align: center;
  padding: 15px 10px;
  border-radius: 5px;
  box-shadow: 0px 0px 20px 0px #e9ecef;
  margin-bottom: 15px;
}

.wrapper.blue h5,
.wrapper.white h5 {
  margin-bottom: 0;
  font-weight: bold;
}

.wrapper.blue h5 {
  color: #ffffff;
}

.wrapper.white h5 {
  color: #303778;
}

.wrapper small {
  text-transform: uppercase;
}

.wrapper.white {
  background-color: #ffffff;
  color: #303778;
}

.wrapper.blue {
  background-color: #303778;
  color: #ffffff;
}

i.fas.fa-arrow-right {
  color: #303778;
}

.date-header {
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 7px 40px 0 rgba(90, 97, 105, 0.1);
  text-align: center;
  padding: 10px 10px;
  margin-bottom: 10px;
}

.date-header p {
  margin: 0;
}
</style>
